import { View } from "binder"
import { BpmnEditorViewModel } from "./bpmnEditor-viewModel"
import Modeler from 'bpmn-js/lib/Modeler';
import { stringIsNullOrEmpty } from "src/common/utilities";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class BpmnEditorView extends View<BpmnEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-D47232F2-E8E3-4AD9-81C2-3313CF0DADFA"
    }
    loadHtml(): string {
        let element = require('./bpmnEditor.html').default;
        let style = require('./bpmnEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set drawing(v: boolean) { this._drawing = v; } public get drawing(): boolean { return this._drawing;} private _drawing: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    public set settingIds(v: boolean) { this._settingIds = v; } public get settingIds(): boolean { return this._settingIds;} private _settingIds: boolean;
    public set settingNotificationReceivers(v: boolean) { this._settingNotificationReceivers = v; } public get settingNotificationReceivers(): boolean { return this._settingNotificationReceivers;} private _settingNotificationReceivers: boolean;
    
    public set xml(v: string) { 
        this._xml = v; 
        this.draw();
    } public get xml(): string { return this._xml;} private _xml: string;
    private viewer;
    async draw(){
        if(this.firstlevelElement==null)
            return;
        if(this.viewer==null)
        {
            let canvas = this.firstlevelElement.querySelector('#bpmnCanvas');
            this.viewer = new Modeler({
                container : canvas,
                keyboard: {
                    bindTo: window
                }
            });
            let bus = this.viewer.get("eventBus");
            bus.on('element.click',function(e){
                this.elementChoosed(e.element);
            }.bind(this));
            
        }
        if(stringIsNullOrEmpty(this.xml)==false)
            await this.viewer.importXML(this.xml);
        else{
            await this.viewer.createDiagram();
        }
    }
    public override onDataContextSet(){
        this.dataContext.updateXml = this.updateXml.bind(this);
    }
    async updateXml():Promise<any>{
        var result = await this.viewer.saveXML({ format: true });
        this.xml = result.xml;
    }
    save(){
        this.dataContext.save();
    }
    public override onRenderCompleted(){
        this.draw();
    }
    public elementChoosed(element){
        if(this.drawing){
            return;
        }
        if(this.settingIds==true){
            this.dataContext.setElementId(element.id);
            return;
        }
        if(this.settingNotificationReceivers){
            this.dataContext.setNotificationReceivers(element.id);
            return;
        }
        if(element.type=='bpmn:UserTask'){
            this.dataContext.showUserTask(element.id);
        }else if(element.type=='bpmn:ScriptTask'){
            this.dataContext.showScriptTask(element.id);
        }else if(element.type=='bpmn:SequenceFlow'){
            this.dataContext.showSequenceFlow(element.id)
        }
    }
}
